import React, { useMemo, useState } from 'react';
import { Form, RadioGroup, Radio } from 'informed'
import { IApplication, TTransferApplicationStepPageProps } from '../types';
import { InputTypeArea } from '../../../elements';
import { IFormApi } from '../../types';
import Axios, { AxiosError } from 'axios';
import { API_URL } from '../../../../lib/const';
import { toast } from 'react-toastify';
import formater from '../../common/formater';
import consts from '../consts';


const PublicWaitReviewContent = ({ application }: { application: IApplication }) => (
  <div className="text-center">
    <h3 className="green">Tudo certo, {' '}
      {(application.assumed_name && application.assumed_name.split(' ')[0]) || application.real_name.split(' ')[0]}.
    </h3>
    <p className="mt-4">
      Sua inscrição no processo <b>{application.process.name}</b> para o curso <b>{application.process.course.name}</b> foi concluída com sucesso.<br />
      A pré-análise dos documentos enviados será realizada, e em breve informaremos o parecer da avaliação. Em caso de aprovação, você receberá orientações sobre as próximas etapas do processo. <br />
    </p>
  </div>
)

const ConvocationWaitReviewContent = () => (
  <div className="text-center">
    <h3 className="green">Prezado(a) candidato(a),</h3>
    <p className="mt-4">
      Atestamos a finalização da 1ª etapa do preenchimento do seu processo de Transferência Externa para o curso de Medicina da Faculdade Ciências Médicas de Minas Gerais.<br />
      <br />
      Pedimos, por gentileza, que acompanhe seu e-mail, pois, caso seja identificada alguma pendência ou necessidade de complementação dos documentos, você receberá a respectiva comunicação por e-mail.<br />
      <br />
      Em caso de dúvidas, permanecemos à disposição pelo telefone: (31) 97212-5339<br />
      <br />
      Atenciosamente,<br />
      Faculdade de Ciências Médicas de Minas Gerais (FCMMG)
    </p>
  </div>
)

// Espelha os e-mails de confirmação de envio (submit_convocation.html e submit.html): na
// convocação a área pediu saudação genérica e o texto de confirmação de recebimento; a
// inscrição pública dos multicursos continua com o texto antigo.
const WaitReviewContent = ({ application }: { application: IApplication }) => (
  application.process.kind === consts.TransferProcessKind.CONVOCATION
    ? <ConvocationWaitReviewContent />
    : <PublicWaitReviewContent application={application} />
)

const ApprovedContent = ({ application }: { application: IApplication }) => (
  <div className="text-center">
    <h3 className="green">Parabéns, {' '}
      {(application.assumed_name && application.assumed_name.split(' ')[0]) || application.real_name.split(' ')[0]}.
    </h3>
    <p className="mt-4">
      Após análise, informamos que a sua inscrição foi aprovada, no processo de <b>{application.process.name}</b> para o <b>{application.deferred_onboarding ? application.deferred_onboarding.field_step : application.desired_onboarding.field_step}</b>º Período do curso de <b>{application.process.course.name}</b>.
      Em breve, entraremos em contato para fornecer orientações sobre a próxima etapa, conforme regulamento."
    </p>
  </div>
)

const ReprovedContent = ({ application }: { application: IApplication }) => (
  <div className="text-center">
    <h3 className="green">Olá, {' '}
      {(application.assumed_name && application.assumed_name.split(' ')[0]) || application.real_name.split(' ')[0]}.
    </h3>
    <p className="mt-4">
      Após análise do seu processo, informamos que não será possível receber sua matrícula devido a {application.disapproval_reason}. <br />
      Agradecemos por sua participação.
    </p>
  </div>
)

const EliminatedContent = () => (
  <div className="text-center">
    <h3 className="green">Prezado(a) candidato(a),</h3>
    <p className="mt-4">
      Informamos que sua participação neste processo de transferência foi encerrada, pois a
      documentação não foi enviada ou não atendeu ao edital dentro do prazo.<br />
      <br />
      Atenciosamente,<br />
      Faculdade de Ciências Médicas de Minas Gerais (FCMMG)
    </p>
  </div>
)

const InReviewContent = ({ application, setApplication }: { application: IApplication, setApplication: (value: ((prevState: IApplication) => IApplication)) => void }) => {
  let previousErrors: any = {};

  const [submiting, setSubmitting] = useState(false);

  const handleReplyIssue = (values: any, formApi: IFormApi) => {
    setSubmitting(true);

    Axios.post(`${API_URL}/transfers/applications/${application.token}/reply_academic_review`, values)
      .then(() => {
        setApplication((prevState) => ({
          ...prevState,
          status: 'Em análise',
          academic_step_status: 'Em análise',
          issues: prevState.issues.map(i => {
            if (i.id === values.issue) {
              return {
                ...i,
                status: 'Resolvida',
                response: values.response,
                resolved_at: formater.date(new Date()),
              }
            }

            return i;
          })
        }))
      })
      .catch(error => {
        const response = (error as AxiosError).response;

        if (response && response.status === 400) {
          const errors = response.data;

          Object.keys(previousErrors).forEach((fieldName) => {
            if (formApi.fieldExists(fieldName)) {
              formApi.setError(fieldName, null);
            }
          });

          previousErrors = { ...errors };

          Object.entries(errors).forEach((e) => {
            if (formApi.fieldExists(e[0])) {
              formApi.setError(e[0], e[1] as string[]);
            }
          });

          if (errors.non_field_errors) {
            toast.error(errors.non_field_errors.join(','))

          } else {
            toast.error('Ocorreu um erro ao responder sua pendência acadêmica.')

          }

        } else {
          toast.error('Ocorreu um erro desconhecido ao responder sua pendência acadêmica.')

        }
      })
      .finally(() => setSubmitting(false))

  }

  const sortedIssues = useMemo(() => {
    return application.issues.filter(i => i.category === 'Acadêmica').sort((a, b) => {
      if (a.created_at == b.created_at) {
        return 0;
      }

      if (a.created_at < b.created_at) {
        return 1;
      }

      return -1;
    })
  }, [application.issues])

  return (
    <>
      <div className="text-center">
        <h3 className="green">Olá, {' '}
          {(application.assumed_name && application.assumed_name.split(' ')[0]) || application.real_name.split(' ')[0]}.
        </h3>
      </div>
      <p className="mt-4">
        Sua documentação foi <strong>aprovada</strong> porém encontramos divergências em relação ao <strong>Período pleiteado</strong>,
        {application.status === 'Em análise' ? ' por favor aguarde até que a nossa equipe avalie suas considerações.' : ' por favor veja as considerações da nossa equipe para darmos continuidade ao seu processo.'}
      </p>
      {sortedIssues.map((issue, index) => (
        <div className="pendencies">
          <div className="pendencies-header">
            <div className="mb-2">
              <label className="pendencies-header-title">Pendência #{sortedIssues.length - index}</label>
              {issue.suggested_onboarding && <small className="d-block"><em>Período sugerido:</em> {issue.suggested_onboarding.field_step}ᵒ</small>}
            </div>
          </div>
          <div className="pendencies-body">
            <p>{issue.content}</p>
            {issue.response && <p><b className="d-block">Resposta: </b>{issue.response}</p>}
          </div>
          {['Enviada', 'Criada'].includes(issue.status) && (
            <Form key={application && application.id} initialValues={{ issue: issue.id }}>
              {({ formState, formApi }: { formState: { values: { result?: 'Accept' | 'Reject' } }, formApi: IFormApi }) => (
                <>
                  <b className="mt-2 d-block">Resposta</b>
                  <RadioGroup style={{ display: 'flex' }} field="result">
                    <div id="defer-options" className="radio-group">
                      <label className="input-radio-type" htmlFor="Accept">Aceitar
                        <Radio value="Accept" id="Accept" />
                        <span className="radiomark" />
                      </label>
                      <label className="input-radio-type" htmlFor="Reject">Recursar
                        <Radio value="Reject" id="Reject" />
                        <span className="radiomark" />
                      </label>
                    </div>
                  </RadioGroup>
                  {formState.values.result && formState.values.result === 'Reject' && (
                    <InputTypeArea required className="mt-1" row="5" col="12" label="Resposta" field="response" />
                  )}
                  <div className="text-right mt-2">
                    <div className="col-md-4 p-0 offset-md-8 col-sm-12">
                      <div className="btn-actions">
                        <button
                          id='btn-submit'
                          className={`btn btn-primary`}
                          onClick={() => handleReplyIssue(formState.values, formApi)}
                          disabled={submiting || !formState.values.result}
                          type="submit"
                        >
                          Responder
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </Form>
          )}
          {issue.resolved_at && <div className="pendencies-date m-1">Respondida em: {issue.resolved_at}</div>}
          <div className="pendencies-date m-1">Enviada em: {issue.sent_at}</div>
        </div>
      ))}
    </>
  )
}

const TransferApplicationApprovingPage = ({ application, setApplication }: TTransferApplicationStepPageProps) => {
  const hasAcademicIssues = !!application.issues.find(i => i.category === 'Acadêmica');
  return (
    <>
      {application.status === 'Aprovado' && <ApprovedContent application={application} />}
      {application.status === 'Reprovado' && <ReprovedContent application={application} />}
      {application.status === 'Eliminado' && <EliminatedContent />}
      {['Em análise', 'Com pendências'].includes(application.status) && hasAcademicIssues && <InReviewContent application={application} setApplication={setApplication} />}
      {application.status === 'Em análise' && !hasAcademicIssues && <WaitReviewContent application={application} />}
    </>
  )
}

export default TransferApplicationApprovingPage;
